import { ThemeDefinition } from 'vuetify';

// Hem och konsumentkunskap HKK
export const homeAndConsumerStudies: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#9ACD48',
    'on-subject-original': '#FFFFFF',
    subject: '#5C8023',
    'on-subject': '#FFFFFF',
    primary: '#45601A',
    'on-primary': '#FFFFFF',
    'primary-container': '#DEEFC3',
    'on-primary-container': '#23300D',
    secondary: '#525B43',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#DADED3',
    'on-secondary-container': '#20231A',
    surface: '#FAFCF7',
    'on-surface': '#1F201D',
    'on-surface-medium': '#4D5049',
    'on-surface-low': '#9A9E94',
    outline: '#818679',
    'outline-variant': '#CDCFC9',
    'inverse-surface': '#374224',
    'inverse-on-surface': '#F3F6EE',
    'inverse-primary': '#D3E9AF',
    'surface-dim': '#DBEBC2',
    'surface-bright': '#FDFEFB',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#F6FAF0',
    'surface-container': '#F1F7E8',
    'surface-container-high': '#E8F2D9',
    'surface-container-highest': '#E4F0D1',
  },
};

export const homeAndConsumerStudiesDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#9ACD48',
    'on-subject-original': '#FBFDF7',
    subject: '#A6D35F',
    'on-subject': '#23300D',
    primary: '#BFDF8B',
    'on-primary': '#23300D',
    'primary-container': '#425C19',
    'on-primary-container': '#F4FAEB',
    secondary: '#CBD1C1',
    'on-secondary': '#20231A',
    'secondary-container': '#4C553F',
    'on-secondary-container': '#F3F4F0',
    surface: '#13150E',
    'on-surface': '#F2F3F2',
    'on-surface-medium': '#CDCFC9',
    'on-surface-low': '#818679',
    outline: '#9A9E94',
    'outline-variant': '#676B61',
    'inverse-surface': '#E7EDDE',
    'inverse-on-surface': '#212815',
    'inverse-primary': '#3A5016',
    'surface-dim': '#13150E',
    'surface-bright': '#3D462F',
    'surface-container-lowest': '#10120C',
    'surface-container-low': '#1B1F14',
    'surface-container': '#23281B',
    'surface-container-high': '#2D3423',
    'surface-container-highest': '#3B432D',
  },
};
